<template>
  <div class="d d_cy">
    <statistics-item
      title="学校情况"
      :list="sortFn(list.schoolTypeData, 'schoolType', schoolTypes, 5)"
      :type="5"
      :base="schoolTypes"
    />
    <statistics-item
      title="大队辅导员校内职级"
      :list="sortFn(list.job, 'type', jobList, 1)"
      :type="1"
      :base="jobList"
    />
    <statistics-item
      title="兼教课程和每周课时"
      :list="sortFn(list.lessonResult, 'concurrentCourses', concurrentCoursesList, 2)"
      :type="2"
      :base="concurrentCoursesList"
    />

    <statistics-item
      title="各项课时"
      :list="sortFn(list.lessonTime, 'type', concurrentCoursesList, 3)"
      :type="3"
      :base="concurrentCoursesList"
    />

    <!-- 中队总数、 中队辅导员总数、 少先队员总数 -->
    <statistics-item title="统计总数" :list="sortFn(list.sumData, '', '', 6)" :type="6" />

    <!-- 聘请校外大队辅导员数据 -->
    <statistics-item
      title="聘请校外大队辅导员数据"
      :list="sortFn(list.schoolCounselorData, '', '', 7)"
      :type="7"
    />

    <!-- 聘请校外中队辅导员数据 -->
    <statistics-item
      title="聘请校外中队辅导员数据"
      :list="sortFn(list.squadronOutsideCounselorData, '', '', 8)"
      :type="8"
    />

    <statistics-item
      title="目前开展分批入队的学校比例"
      :list="sortFn(list.batchTeamData, 'type', batchTeamList, 1)"
      :type="1"
      :base="batchTeamList"
      :titleType="2"
      :totalType="true"
    />
    <statistics-item
      title="首次佩戴的红领巾是否由学校统一配发统计"
      :list="sortFn(list.redScarfData, 'type', yn, 1)"
      :type="1"
      :base="yORn"
      :titleType="2"
      :totalType="true"
    />
    <statistics-item
      title="首次佩戴的队徽徽章是否由学校统一配发"
      :list="sortFn(list.badgeData, 'type', yn, 1)"
      :type="1"
      :base="yORn"
      :titleType="2"
      :totalType="true"
    />
    <statistics-item
      title="目前开展“红领巾奖章”活动的学校比例"
      :list="sortFn(list.redScarfMedalData, 'type', starts, 1)"
      :type="1"
      :base="starts"
      :titleType="2"
      :totalType="true"
    />
    <statistics-item
      title="颁发一星章的学校比例"
      :list="sortFn(list.oneStarData, 'type', starts, 1)"
      :type="1"
      :base="starts"
      :titleType="2"
      :totalType="true"
    />
    <statistics-item
      title="成立学校少工委学校比例"
      :list="sortFn(list.sgwExistsData, 'type', sgwlist, 1)"
      :type="21"
      :base="sgwlist"
      :titleType="2"
    />
    <statistics-item
      title="学校少工委主任职务比例"
      :list="sortFn(list.sgwJobData, 'type', sgwJobList, 1)"
      :type="1"
      :base="sgwJobList"
      :titleType="2"
    />

    <statistics-item
      title="1年内召开少代会的比例"
      :list="sortFn(list.sgwMeetingTimeData, 'type', meetingList, 9)"
      :type="9"
      :base="meetingList"
      :titleType="2"
    />
  </div>
</template>

<script>
import _ from "lodash";
import { reactive, toRefs } from "vue";
import StatisticsItem from "@/components/StatisticsItem";
import {
  meetingList,
  sexArr,
  ageArr,
  eduArr,
  zzmmArr,
  jobArr,
  batchTeamList,
  yn,
  jobList,
  concurrentCoursesList,
  starts,
  schoolTypes,
  sgwlist,
  sgwJobList,
  yORn,
} from "@/common/js";
export default {
  name: "SchoolInfo",
  props: {
    list: Object,
  },
  setup() {
    const state = reactive({
      // formData: props.list,
    });
    const compare = (property) => {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
      };
    };
    const sortFn = (list, key, base, type) => {
      // && list.length > 0
      if (list) {
        if (type == 1) {
          for (let i = 0; i < base.length; i++) {
            if (base[i].key == -1) {
              continue;
            }
            const res = list.filter((res) => res[key] == base[i].key);
            if (res.length == 0) {
              list.push({ type: base[i].key, total: 0 });
            }
          }
          return list.sort(compare(key));
        } else if (type == 2) {
          for (let i of base) {
            const res = list.filter((res) => i.key == res.concurrentCourses);
            if (res.length == 0) {
              // 空的追加默认数据
              const obj = {
                avgHour: 0,
                concurrentCourses: i.key,
                maxHour: 0,
                total: 0,
                _id: i.key,
              };
              list.push(obj);
            }
          }
          return list.sort(compare(key));
        } else if (type == 3) {
          const arrClass = [
            "6课时（含）以下",
            "6—12课时（含）",
            "12—18课时（含）",
            "18—24课时（含）",
            "24课时以上",
          ];
          const arr = [];
          for (let i of base) {
            let r = [];
            for (let j of arrClass) {
              const obj = { category: j, total: 0, type: i.key, title: i.value };
              r.push(obj);
            }
            arr.push(r.sort(compare(key)));
          }
          // 遍历 修改值
          for (let i = 0; i < arr.length; i++) {
            let item = arr[i];
            for (let c = 0; c < item.length; c++) {
              let cItem = item[c];
              const res = list.filter((res) => res.type == cItem.type);
              if (res.length > 0) {
                let t = 0;
                for (let r of res) {
                  if (r.category == cItem.category) {
                    t += r.total;
                  }
                }
                item[c] = {
                  ...item[c],
                  total: t,
                };
              } else {
                break;
              }
            }
          }
          return arr;
        } else if (type == 5) {
          const arr = [];
          for (let i of base) {
            arr.push({
              type: i.key,
            });
          }
          // 分组计算
          const groupList = _.groupBy(list, "schoolType");
          const newList = [];
          Object.keys(groupList).map((r) => {
            let item = groupList[r];

            const total = _.sumBy(item, function (o) {
              return o.total;
            });
            // 计算不符合建队条件数量
            let totalIsnot = _.sumBy(item, function (o) {
              if (o.schoolBuildingTeam == 3) {
                return o.total;
              } else {
                return 0;
              }
            });
            // 计算大队辅导员基数
            const counselorTotal = _.sumBy(item, function (o) {
              if (o.schoolBuildingTeam == 1) {
                return o.total;
              } else {
                return 0;
              }
            });

            let obj = {
              type: item[0].schoolType,
              schoolBuildingTeam: 0, // 是否建队
              teamNum: 0, //建队总数
              brigadeCounselor: 0, // 设置大队辅导员
              counselorNum: 0, // 设置大队辅导员总数
            };
            for (let j = 0; j < item.length; j++) {
              let jItem = item[j];
              if (jItem.schoolBuildingTeam == 1) {
                obj.schoolBuildingTeam += jItem.total;
              }
              obj.teamNum = total - totalIsnot;

              if (jItem.isBrigadeCounselor == 1) {
                obj.brigadeCounselor += jItem.total;
              }
              obj.counselorNum = counselorTotal;
            }
            newList.push(obj);
          });
          console.log("newList", newList);

          if (newList.length > 0) {
            for (let i = 0; i < arr.length; i++) {
              let item = arr[i];
              const res = newList.filter((res) => res.type == item.type);
              if (res.length > 0) {
                arr[i] = {
                  ...arr[i],
                  ...res[0],
                };
              }
            }
          }
          return arr;
        } else if (type == 9) {
          let newArr = [];
          for (let i of base) {
            const res = list.filter((r) => r.date == i.key);
            let total = 0;
            if (res.length > 0) {
              total = res[0].total;
            }
            newArr.push({
              value: i.value,
              total,
              type: i.key,
            });
          }

          return newArr;
        } else {
          return list;
        }
      }

      let arr = [];
      if (type == 1) {
        for (let item of base) {
          arr.push({ type: item.key, total: 0 });
        }
      } else if (type == 2) {
        for (let item of base) {
          arr.push({
            avgHour: 0,
            concurrentCourses: item.key,
            maxHour: 0,
            total: 0,
            _id: item.key,
          });
        }
      } else if (type == 3) {
        const arrClass = [
          "6课时（含）以下",
          "6—12课时（含）",
          "12—18课时（含）",
          "18—24课时（含）",
          "24课时以上",
        ];
        for (let i of base) {
          let r = [];
          for (let j of arrClass) {
            const obj = { category: j, total: 0, type: i.key, title: i.value };
            r.push(obj);
          }
          arr.push(r.sort(compare(key)));
        }
      } else if (type == 5) {
        for (let item of base) {
          arr.push({
            type: item.key,
            schoolBuildingTeam: 0, // 是否建队
            teamNum: 0, //建队总数
            brigadeCounselor: 0, // 设置大队辅导员
            counselorNum: 0, // 设置大队辅导员总数
          });
        }
      } else if (type == 6) {
        const obj = {
          sq: 0,
          sqcn: 0,
          yn: 0,
        };
        return obj;
      } else if (type == 7) {
        const obj = {
          boc: 0,
          total: 0,
          gte2Num: 0,
        };
        return obj;
      } else if (type == 8) {
        const obj = {
          sqoc: 0,
          sq: 0,
          gte2Num: 0,
        };
        return obj;
      } else if (type == 9) {
        let newArr = [];
        for (let i of base) {
          newArr.push({
            value: i.value,
            total: 0,
            type: i.key,
          });
        }
        return newArr;
      }

      return arr;
    };
    return {
      ...toRefs(state),
      sexArr,
      ageArr,
      eduArr,
      zzmmArr,
      jobArr,
      batchTeamList,
      yn,
      jobList,
      concurrentCoursesList,
      starts,
      schoolTypes,
      sgwlist,
      sgwJobList,
      sortFn,
      meetingList,
      yORn,
    };
  },
  components: {
    StatisticsItem,
  },
};
</script>

<style lang="less" scoped></style>
